import { Campaign } from '@/lib/graphql/generated/graphql';

export function isFarmingBrand(
  latestPreviousCampaigns: Campaign[] | undefined | null
): boolean {
  return (latestPreviousCampaigns ?? []).length > 0;
}
